import ReservationTypeAll from '../Assets/reservation_type_all.png';
import constants from '../Config/constants';
import DateHelper from '../Helper/Date';

const { DEFAULT_DISTANCE, DISTANCE_UNIT, PRODUCT_TYPES } = constants;

const checkout = {
  keys: {
    ORDER_TYPE: 'orderType',
    DELIVERY_ADDRESS: 'deliveryAddress',
    DELIVERY_SCHEDULE: 'deliverySchedule',
    DELIVERY_SPEED: 'deliverySpeed',
    USER_DETAILS: 'userDetails',
    PAYMENT_METHOD: 'paymentMethod',
    PAYMENT_OPTIONS: 'paymentOptions',
    VEHICLE_OPTIONS: 'vehicleOptions',
    THIRD_PARTY_PICKUP: 'thirdPartyPickup',
    VEHICLE_INFORMATION: 'vehicleInformation',
    REQUEST_CUTLERY: 'requestCutlery',
    NOTE: 'note',
    PROMO_CODE_INPUT: 'promoCodeInput',
    PROMO_CODE: 'promoCode',
    PROMO_STORE: 'promoStore', // promo code added to basket in store page
    CONTINUE_TO_PAYMENT: 'continueToPayment', // not in form, used for going back to payment link
  },
  initialValue: {
    checkoutFlag: {
      checkoutStoreId: null, // for flag when navigating to address selection when user is in checkout page
      addressSelection: false,
      dropOffOptionSelection: false,
    },
    checkoutData: [],
    trackOrder: '',
    storeInfo: {}, // this value must be dispatch before navigating to checkout page
    isPromoOk: true,
  },
};

const filter = {
  useCase: { HOME: 'home', SEARCH: 'search' },
  filterType: { CATEGORY: 'category', TAG: 'tag' },
  parentCategory: PRODUCT_TYPES[0],
  homeInitialFilterValue: {
    category: [],
    tags: [
      {
        id: 2,
        label: `Within ${DEFAULT_DISTANCE} ${DISTANCE_UNIT}`,
        values: [
          {
            label: `Within ${DEFAULT_DISTANCE} ${DISTANCE_UNIT}`,
            value: DEFAULT_DISTANCE,
          },
        ],
        paramName: 'distance',
      },
    ],
  },
  searchInitialFilterValue: {
    category: [],
    tags: [
      {
        id: 2,
        label: `Within ${DEFAULT_DISTANCE} ${DISTANCE_UNIT}`,
        values: [
          {
            label: `Within ${DEFAULT_DISTANCE} ${DISTANCE_UNIT}`,
            value: DEFAULT_DISTANCE,
          },
        ],
        paramName: 'distance',
      },
    ],
  },
  reservationFilterValue: {
    reservationType: {
      label: 'All',
      value: 'all',
      image: ReservationTypeAll,
    },
    location: {
      // -> default to makati
      latitude: 14.5573752,
      longitude: 121.0227371,
    },
    date: '',
    time: DateHelper.getNextMealTimeAsString(constants.DBTIME_FORMAT),
    party_size: 2,
  },
  reservationStoreFilterValue: {
    tab: constants.RESERVATION_TYPE.DINING,
    eventDate: '', // formatted
    eventDateRange: undefined, // raw
    tableDate: '',
    tableTime: '',
    tableServingTime: '',
    partySize: 2,
  },
};

/** @const */
const mealPlan = {
  type: {
    threeDay: '3_day',
    fiveDay: '5_day',
  },
  initialValue: {
    cart: [], // value of this should be [{ day: 1, items: [...itemObject] }]
    checkoutData: {}, // value of this is { [checkout.keys]: any }
    checkoutFlag: false,
    day: { label: 'Monday', value: 1 },
    isCheckingOut: false,
    type: '', // value of this is meaPlan.type
  },
  // enum on this component App/Screens/Store/MealPlanHint.tsx rely on hint object keys
  hint: {
    // common
    showFeatured: false,
    isShownFeatured: false,
    showExclusive: false,
    isShownExclusive: false,
    showNext: false,
    isShownNext: false,
    showPrev: false,
    isShownPrev: false,
    showCreate: false,
    isShownCreate: false,
    // mobile specific
    showReview: false,
    isShownReview: false,
    showFloatingButtonHint: true,
  },
};

export { checkout, filter, mealPlan };
